<ag-grid-angular
  class="custom-ag-grid"
  [class]="themeClass"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  [gridOptions]="gridOptions"
  [rowSelection]="rowSelection"
  [getRowId]="getRowId"
  [isFullWidthRow]="isFullWidthRow"
  [fullWidthCellRenderer]="fullWidthCellRenderer"
  [rowClassRules]="rowClassRules"
  [getRowHeight]="getRowHeight"
  [statusBar]="statusBar"
  [detailRowAutoHeight]="detailRowAutoHeight"
  [detailCellRenderer]="detailCellRenderer"
  [detailCellRendererParams]="detailCellRendererParams"
  [masterDetail]="masterDetail"
  [quickFilterText]="quickFilterText"
  [defaultExcelExportParams]="defaultExcelExportParams"
  [defaultCsvExportParams]="defaultCsvExportParams"
  [excelStyles]="excelStyles"
  [groupDisplayType]="groupDisplayType"
  [pagination]="pagination"
  [paginationPageSize]="pageSizeService.getPageSize"
  [paginationPageSizeSelector]="paginationPageSizeSelector"
  [suppressCellFocus]="suppressCellFocus"
  [suppressContextMenu]="suppressContextMenu"
  [domLayout]="domLayout"
  [rowModelType]="rowModelType"
  [enableAdvancedFilter]="enableAdvancedFilter"
  [suppressPaginationPanel]="suppressPaginationPanel"
  [suppressScrollOnNewData]="suppressScrollOnNewData"
  [floatingFiltersHeight]="floatingFiltersHeight"
  [icons]="icons"
  [headerHeight]="headerHeight"
  [suppressMenuHide]="suppressMenuHide"
  (selectionChanged)="onSelectionChanged($event)"
  (paginationChanged)="onPaginationChanged($event)"
  (filterChanged)="onFilterChanged($event)"
  (gridReady)="onGridReady($event)"
  (stateUpdated)="onStateUpdated($event)"
  (sortChanged)="sortChanged.emit($event)"
/>

@if (pagination) {
  <app-ag-custom-pagination
    [currentPage]="currentPage"
    [pageNumbers]="pageNumbers"
    [totalPages]="totalPages"
    [paginationPageSize]="pageSizeService.getPageSize"
    [paginationPageSizeSelector]="pageSizeList"
    [showPageSizeSelector]="paginationPageSizeSelector"
    (previousPage)="goToPreviousPage()"
    (nextPage)="goToNextPage()"
    (selectPage)="goToPage($event)"
  />
}
